import React from 'react';

import { Icon } from '@/shared/types/icon';
import { IntegrationType } from '@/shared/types/integration';

import IntegrationCustom from './Custom/Custom';
import IntegrationEmail from './Email/Email';
import IntegrationFacebook from './Facebook/Facebook';
import IntegrationFront from './Front/Front';
import { iconComponents } from './icons';
import IntegrationInfobipRcs from './InfobipRcs/InfobipRcs';
import IntegrationInfobipSms from './InfobipSms/InfobipSms';
import IntegrationIntercom from './Intercom/Intercom';
import IntegrationLiveChat from './LiveChat/LiveChat';
import IntegrationMstatViber from './MstatViber/MstatViber';
import IntegrationSlack from './Slack/Slack';
import IntegrationSmartlead from './Smartlead/Smartlead';
import IntegrationSunco from './Sunco/Sunco';
import IntegrationTelnyxVoice from './TelnyxVoice/TelnyxVoice';
import IntegrationTwilioVoice from './TwilioVoice/TwilioVoice';
import IntegrationViber from './Viber/Viber';
import IntegrationWebWidget from './Web/Web';
import IntegrationWebVoice from './WebVoice/WebVoice';
import IntegrationWhatsapp from './Whatsapp';
import IntegrationZendesk from './Zendesk/Zendesk';

export { IntegrationIcon, getIntegrationIcon, iconComponents } from './icons';

interface IntegrationComponentConfig {
  Icon: React.FC<Icon>;
  ConfigurationComponent?: React.FunctionComponent;
}

export const integrationByType: Record<IntegrationType, IntegrationComponentConfig> = {
  [IntegrationType.ZENDESK]: {
    Icon: iconComponents[IntegrationType.ZENDESK],
    ConfigurationComponent: IntegrationZendesk,
  },
  [IntegrationType.SUNCO]: {
    Icon: iconComponents[IntegrationType.SUNCO],
    ConfigurationComponent: IntegrationSunco,
  },
  [IntegrationType.WEB]: {
    Icon: iconComponents[IntegrationType.WEB],
    ConfigurationComponent: IntegrationWebWidget,
  },
  [IntegrationType.EMAIL]: {
    Icon: iconComponents[IntegrationType.EMAIL],
    ConfigurationComponent: IntegrationEmail,
  },
  [IntegrationType.FACEBOOK]: {
    Icon: iconComponents[IntegrationType.FACEBOOK],
    ConfigurationComponent: IntegrationFacebook,
  },
  [IntegrationType.INSTAGRAM]: {
    Icon: iconComponents[IntegrationType.INSTAGRAM],
    ConfigurationComponent: IntegrationFacebook,
  },
  [IntegrationType.INFOBIP_SMS]: {
    Icon: iconComponents[IntegrationType.INFOBIP_SMS],
    ConfigurationComponent: IntegrationInfobipSms,
  },
  [IntegrationType.INFOBIP_RCS]: {
    Icon: iconComponents[IntegrationType.INFOBIP_RCS],
    ConfigurationComponent: IntegrationInfobipRcs,
  },
  [IntegrationType.WHATSAPP]: {
    Icon: iconComponents[IntegrationType.WHATSAPP],
    ConfigurationComponent: IntegrationWhatsapp,
  },
  [IntegrationType.VIBER]: {
    Icon: iconComponents[IntegrationType.VIBER],
    ConfigurationComponent: IntegrationViber,
  },
  [IntegrationType.MSTAT_VIBER]: {
    Icon: iconComponents[IntegrationType.MSTAT_VIBER],
    ConfigurationComponent: IntegrationMstatViber,
  },
  [IntegrationType.INTERCOM]: {
    Icon: iconComponents[IntegrationType.INTERCOM],
    ConfigurationComponent: IntegrationIntercom,
  },
  [IntegrationType.LIVECHAT]: {
    Icon: iconComponents[IntegrationType.LIVECHAT],
    ConfigurationComponent: IntegrationLiveChat,
  },
  [IntegrationType.FRONT]: {
    Icon: iconComponents[IntegrationType.FRONT],
    ConfigurationComponent: IntegrationFront,
  },
  [IntegrationType.SMARTLEAD]: {
    Icon: iconComponents[IntegrationType.SMARTLEAD],
    ConfigurationComponent: IntegrationSmartlead,
  },
  [IntegrationType.TWILIO_VOICE]: {
    Icon: iconComponents[IntegrationType.TWILIO_VOICE],
    ConfigurationComponent: IntegrationTwilioVoice,
  },
  [IntegrationType.TELNYX_VOICE]: {
    Icon: iconComponents[IntegrationType.TELNYX_VOICE],
    ConfigurationComponent: IntegrationTelnyxVoice,
  },
  [IntegrationType.WEB_VOICE]: {
    Icon: iconComponents[IntegrationType.WEB_VOICE],
    ConfigurationComponent: IntegrationWebVoice,
  },
  [IntegrationType.AGORA_VOICE]: { Icon: iconComponents[IntegrationType.AGORA_VOICE] },
  [IntegrationType.SLACK]: {
    Icon: iconComponents[IntegrationType.SLACK],
    ConfigurationComponent: IntegrationSlack,
  },
  [IntegrationType.CUSTOM]: {
    Icon: iconComponents[IntegrationType.CUSTOM],
    ConfigurationComponent: IntegrationCustom,
  },
};

export const getIntegrationByType = (type: IntegrationType): IntegrationComponentConfig | null => {
  if (type in integrationByType) {
    return integrationByType[type];
  }
  return null;
};
